import {
	getRangeProgress as getRangeProgressValue
} from "./form-range-utils";

export const isSectionConfig = item => {
	return Array.isArray(item?.fields) || Array.isArray(item?.subsections);
};

export const normalizeSections = (formFields = []) => {
	if (formFields.length === 0) {
		return [];
	}

	const hasSections = formFields.some(isSectionConfig);

	if (hasSections) {
		return formFields.map(item => {
			if (isSectionConfig(item)) {
				return item;
			}

			return {
				fields: [item]
			};
		});
	}

	return [
		{
			fields: formFields
		}
	];
};

export const getFieldsFromSections = (formFields = []) => {
	const sections = normalizeSections(formFields);

	return sections.reduce((acc, section) => {
		const sectionFields = section.fields || [];

		const subsectionFields = (section.subsections || []).reduce((subAcc, subsection) => {
			return [
				...subAcc,
				...(subsection.fields || [])
			];
		}, []);

		return [
			...acc,
			...sectionFields,
			...subsectionFields
		];
	}, []);
};

export const createInitialValues = formFields => {
	const fields = getFieldsFromSections(formFields);

	return fields.reduce((acc, field) => {
		acc[field.name] = field.defaultValue ?? "";
		return acc;
	}, {});
};

export const getFormRangeProgress = ({
	field,
	value
}) => {
	return `${getRangeProgressValue({
		field,
		value
	})}%`;
};

export const getSubmitDisabled = ({
	loading,
	values,
	isSubmitDisabled
}) => {
	if (loading) {
		return true;
	}

	if (typeof isSubmitDisabled === "function") {
		return isSubmitDisabled(values);
	}

	return Boolean(isSubmitDisabled);
};